"use client";

import { useDataFastGoals } from "@/hooks/useDataFastGoals";
import { useStickyCtaState } from "@/hooks/use-sticky-cta";
import { cn } from "@/lib/utils";
import { buttonClass, scrollToSection } from "./ui-tokens";

// Barra do celular que entra quando o CTA do hero sai da tela. O estado vem de
// useStickyCtaState porque o botão flutuante do WhatsApp (WhatsAppButton.tsx)
// precisa entrar e sair junto com esta barra.
//
// Escondida, ela fica `inert` — não `aria-hidden` sobre um link focável, que
// deixava o Tab parar num botão invisível.
export default function StickyCta() {
  const visible = useStickyCtaState() === "visible";
  const { trackNavClicked } = useDataFastGoals();

  return (
    <div
      inert={!visible}
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 transition-[translate] duration-300 ease-(--lp-ease-out) md:hidden",
        visible ? "translate-y-0" : "translate-y-full",
      )}
    >
      <div className="flex items-center gap-3 bg-background/95 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-1px_0_0_var(--lp-hairline)] backdrop-blur-md">
        <div className="min-w-0 flex-1">
          <p className="text-sm leading-tight font-semibold text-foreground">
            A partir de R$ 97/mês
          </p>
          <p className="text-xs leading-tight text-muted-foreground">
            7 dias grátis · cobrança só no 8º dia
          </p>
        </div>
        <a
          href="#precos"
          onClick={(e) => {
            e.preventDefault();
            trackNavClicked("sticky_cta");
            scrollToSection("precos");
          }}
          className={buttonClass("primary", "md", "shrink-0")}
        >
          Ver planos
        </a>
      </div>
    </div>
  );
}
